import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { appendRandomQueryString } from '../../../modules/TCIUtils';
import UploadModal from './UploadModal';

export default class SaveToGoogleDrive extends Component {
  static propTypes = {
    assessmentLibrary: PropTypes.bool,
    button: PropTypes.bool,
    canToggleLanguage: PropTypes.bool,
    fileName: PropTypes.string,
    fileUrl: PropTypes.string.isRequired,
    headerLabel: PropTypes.string,
    linkClasses: PropTypes.string,
    linkText: PropTypes.string,
    wrapper_classes: PropTypes.string,
  };

  static defaultProps = {
    assessmentLibrary: false,
    button: true,
    canToggleLanguage: false,
    fileName: 'TCI File',
    headerLabel: 'Save to Google Drive',
    linkClasses: '',
    linkText: 'Save To Drive',
    wrapper_classes: '',
  };

  constructor(props) {
    super(props);
    this.state = { modalHasBeenOpened: false, modalIsOpen: false, token: null };
    this._openUploadModal = this._openUploadModal.bind(this);
    this._closeUploadModal = this._closeUploadModal.bind(this);
  }

  _openUploadModal(event) {
    event.preventDefault();

    if (!window.googleClientLoaded) return;

    tokenClient.callback = async (response) => {
      this.setState({
        token: response.access_token
      });

      const xhr = new XMLHttpRequest();
      xhr.open('GET', 'https://www.googleapis.com/oauth2/v3/userinfo');
      xhr.setRequestHeader('Authorization', `Bearer ${response.access_token}`);
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          this.setState({ modalHasBeenOpened: true, modalIsOpen: true, ...xhr.response });
        }
        else {
          this.setState({ token: null });
        }
      };

      xhr.send();
    };

    tokenClient.requestAccessToken({ prompt: 'consent' });
  }

  _closeUploadModal() {
    this.setState({ modalIsOpen: false });
  }

  renderModal() {
    if (!this.state.modalHasBeenOpened) return null;

    return (
      <UploadModal
        assessmentLibrary={this.props.assessmentLibrary}
        canToggleLanguage={this.props.canToggleLanguage}
        closeModal={this._closeUploadModal}
        email={this.state.email}
        fileName={this.props.fileName}
        fileUrl={appendRandomQueryString(this.props.fileUrl)}
        headerLabel={this.props.headerLabel}
        isOpen={this.state.modalIsOpen}
        name={this.state.name}
        picture={this.state.picture}
        token={this.state.token}
      />
    );
  }

  renderButton() {
    return (
      <span>
        <button
          type="button"
          onClick={this._openUploadModal}
        >
          Save To Drive
        </button>
      </span>
    );
  }

  renderLink() {
    return (
      <a
        className={`${this.props.linkClasses} js-prevent-default`}
        dangerouslySetInnerHTML={{ __html: this.props.linkText }}
        href="#"
        role="button"
        onClick={this._openUploadModal}
      />
    );
  }

  render() {
    return (
      <div className={this.props.wrapper_classes} title="Save to Google Drive">
        {this.props.button ? this.renderButton() : this.renderLink()}
        {this.renderModal()}
      </div>
    );
  }
}
